// extracted by mini-css-extract-plugin
export default {"inputBlock":"input_inputBlock__BeXnR","label":"input_label__wRYoR","input":"input_input__BO5uV","labelTop":"input_labelTop__EIsUK"};